export enum CarouselTypeEnum {
	SIMPLE = 'simple',
	SEARCH = 'search',
	CAPTION = 'caption',
}
